import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faEnvelope,
  faPaperPlane,
  faPhone,
  faUser,
  faClock,
  faCalendar,
} from '@fortawesome/pro-solid-svg-icons';
import { ContactService } from '../../../core/services/contact.service';
import { PopupInfoService } from '../../../shared/services/popup-info.service';
import { Auth } from '../../../core/auth/auth';
import { SDiContact } from '../../../core/models/sdi-contact.model';

@Component({
  selector: 'app-contact-page',
  imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
  templateUrl: './contact-page.html',
  styleUrls: ['./contact-page.scss'],
})
export class ContactPage {
  private readonly fb = inject(FormBuilder);
  private readonly contactService = inject(ContactService);
  private readonly popupInfoService = inject(PopupInfoService);
  private readonly auth = inject(Auth);

  faEnvelope = faEnvelope;
  faPaperPlane = faPaperPlane;
  faPhone = faPhone;
  faUser = faUser;
  faClock = faClock;
  faCalendar = faCalendar;

  contactForm: FormGroup;
  isLoading = false;
  isProfileLoading = false;
  showMessageForm = false;
  sdiContact?: SDiContact;

  get currentUser() {
    return this.auth.currentUser;
  }

  get infoProfile() {
    return this.auth.infoProfile;
  }

  constructor() {
    this.contactForm = this.fb.group({
      subject: ['', [Validators.required, Validators.minLength(3)]],
      message: ['', [Validators.required, Validators.minLength(10)]],
    });
    this.loadContactInfo();
  }

  loadContactInfo(): void {
    if (this.auth.infoProfile) {
      this.sdiContact = this.auth.infoProfile.sdi_contact || undefined;
    } else {
      this.isProfileLoading = true;
      this.auth.getProfile().subscribe({
        next: (response) => {
          if (response?.sdi_contact) {
            this.sdiContact = response.sdi_contact;
          }
          this.isProfileLoading = false;
        },
        error: () => {
          this.isProfileLoading = false;
        },
      });
    }
  }

  openMessageForm(): void {
    this.showMessageForm = true;
  }

  closeMessageForm(): void {
    this.showMessageForm = false;
    this.contactForm.reset();
  }

  onSubmit(): void {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;

    this.contactService.sendEmail(this.contactForm.value).subscribe({
      next: () => {
        this.popupInfoService.showSuccess('Mensaje enviado correctamente');
        this.contactForm.reset();
        this.closeMessageForm();
        this.contactForm.markAsPristine();
        this.isLoading = false;
      },
      error: () => {
        const msg = 'Error al enviar el mensaje, por favor inténtalo de nuevo más tarde.';
        this.popupInfoService.showError(msg);
        this.isLoading = false;
      },
    });
  }

  get f() {
    return this.contactForm.controls;
  }
}
